module.exports = __webpack_public_path__ + "img/zhinengjiaju.dc0beec1.png";